module.exports = __webpack_public_path__ + "static/media/play_button.e2a88fae.png";